import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import UserLocationList from './components/UserLocationList';

const UsersLocation = () => {
  return renderComponent(<UserLocationList />);
};

export default UsersLocation;
